import {
  LOADING_PRODUCTS,
  RECEIVE_PRODUCTS,
  FINISH_RECEIVE_BY_STATUS,
  LOADING_SUBMIT_PRODUCT,
  SUBMIT_PRODUCT_SUCCESS,
  FINISH_SUBMIT_PRODUCT,
  PRODUCT_REQUEST_ERROR,
  LOADING_PRODUCT,
  RECEIVE_PRODUCT_SUCCESS,
  FINISH_LOADING_PRODUCTS,
  ERROR_LOADING_PRODUCTS,
  SHOW_PRODUCT_MODAL,
  CLOSE_PRODUCT_MODAL,
  DELETE_PRODUCTS_FROM_LIST,
  ORDER_PRODUCT_ITEM,
  ORDER_CATEGORY_ITEM,
  COLLAPSE_CATEGORY,
  SET_COLLAPSE_ALL_CATEGORIES,
  TOGGLE_PRODUCTS_LIST_PRODUCT,
  TOGGLE_PRODUCTS_LIST_CATEGORY,
  TOGGLE_ALL_PRODUCTS,
  UPDATE_PRODUCT_STATUS_SUCCESS,
  UPDATE_PRODUCTS_CHECKED_QTTY,
  INSERT_NEW_CATEGORY_IN_PRODUCTS_LIST,
  UPDATE_PRODUCT_CATEGORY_NAME,
} from './actions';
import { PRODUCT_STATUS } from '../../helpers/constants';
import {
  isCheckedAllProducts,
  isProductCheckedOrInactive,
  isProductInactive,
  isAnyProductActive,
} from '../../helpers/products';

const initialModalState = {
  type: '',
  show: false,
  data: {},
};

const initialState = {
  categories: [],
  isLoading: false,
  isLoadingProduct: false,
  isLoadingSubmit: false,
  finishReceiveProducts: false,
  finishSubmitProduct: false,
  export: false,
  error: null,
  errorLoading: null,
  qttyProductsSelected: {
    categories: 0,
    products: 0,
  },
  modalProduct: initialModalState,
};

export default function products(state = initialState, action) {
  const { currPos, newPos } = action;

  switch (action.type) {
    case LOADING_PRODUCTS:
      return {
        ...state,
        isLoading: action.payload,
        errorLoading: null,
      };
    case FINISH_LOADING_PRODUCTS:
      return {
        ...state,
        isLoading: false,
        finishReceiveProducts: true,
      };
    case RECEIVE_PRODUCTS:
      return {
        ...state,
        categories: action.payload,
        export: action.exportProducts || false,
        finishReceiveProducts: true,
        isLoading: false,
        errorLoading: null,
      };
    case FINISH_RECEIVE_BY_STATUS:
      return {
        ...state,
        finishReceiveProducts: false,
        isLoading: false,
        errorLoading: null,
      };
    case LOADING_SUBMIT_PRODUCT:
      return {
        ...state,
        isLoadingSubmit: true,
      };
    case SUBMIT_PRODUCT_SUCCESS:
      return {
        ...state,
        categories: action.product
          ? state.categories.map(cat => ({
              ...cat,
              products: cat.products.map(prod => {
                if (prod.id === action.product.id) {
                  return {
                    ...prod,
                    ...action.product,
                  };
                }
                return prod;
              }),
            }))
          : state.categories,
        isLoadingSubmit: false,
        finishSubmitProduct: true,
        error: null,
      };
    case FINISH_SUBMIT_PRODUCT:
      return {
        ...state,
        finishSubmitProduct: false,
      };
    case PRODUCT_REQUEST_ERROR:
      return {
        ...state,
        error: { ...action.error },
        isLoadingSubmit: false,
        finishSubmitProduct: true,
      };
    case LOADING_PRODUCT:
      return {
        ...state,
        isLoadingProduct: true,
      };
    case RECEIVE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoadingProduct: false,
      };
    case ERROR_LOADING_PRODUCTS:
      return {
        ...state,
        isLoading: false,
        errorLoading: action.payload,
      };
    case SHOW_PRODUCT_MODAL:
      return {
        ...state,
        ...initialModalState,
        modalProduct: {
          type: action.modalType,
          data: action.data,
          show: true,
        },
      };
    case CLOSE_PRODUCT_MODAL:
      return {
        ...state,
        finishSubmitProduct: false,
        error: null,
        modalProduct: initialModalState,
      };
    case DELETE_PRODUCTS_FROM_LIST:
      return {
        ...state,
        categories: state.categories
          .filter(cat => !action.data.categories.some(idCategory => idCategory === cat.id))
          .map(cat => ({
            ...cat,
            products: cat.products.filter(prod =>
              action.data.products.find(c => c.categoryId === cat.id)
                ? !action.data.products
                    .find(c => c.categoryId === cat.id)
                    .products.some(idProd => idProd === prod.id)
                : true
            ),
          })),
      };
    case ORDER_PRODUCT_ITEM:
      let categoryProducts = [...state.categories.find(c => c.id === action.categoryId).products];

      categoryProducts = swapPositions(categoryProducts, currPos, newPos);

      return {
        ...state,
        categories: state.categories.map(category =>
          category.id === action.categoryId
            ? {
                ...category,
                products: categoryProducts,
              }
            : category
        ),
      };
    case ORDER_CATEGORY_ITEM:
      let orderCategories = [...state.categories];

      orderCategories = swapPositions(orderCategories, currPos, newPos);

      return {
        ...state,
        categories: orderCategories,
      };
    case COLLAPSE_CATEGORY:
      return {
        ...state,
        categories: state.categories.map(category =>
          category.id === action.id
            ? {
                ...category,
                isOpen: !category.isOpen,
              }
            : category
        ),
      };
    case SET_COLLAPSE_ALL_CATEGORIES:
      return {
        ...state,
        categories: state.categories.map(category => ({
          ...category,
          isOpen: category.products.length > 0 ? action.payload : category.isOpen,
        })),
      };
    case TOGGLE_PRODUCTS_LIST_CATEGORY:
      return {
        ...state,
        categories: toggleCategory(action.categoryId, state.categories),
      };
    case TOGGLE_PRODUCTS_LIST_PRODUCT:
      return {
        ...state,
        categories: toggleProduct(action.categoryId, action.productId, state.categories),
      };
    case TOGGLE_ALL_PRODUCTS:
      const checkedAll = isCheckedAllProducts(state.categories);
      return {
        ...state,
        categories: state.categories.map(cat => ({
          ...cat,
          checked: isAnyProductActive(cat.products) && !checkedAll,
          products: cat.products.map(prod => ({
            ...prod,
            checked: isProductInactive(prod) ? false : !checkedAll,
          })),
        })),
      };
    case UPDATE_PRODUCTS_CHECKED_QTTY:
      return {
        ...state,
        qttyProductsSelected: {
          categories: getCategoriesSelectedLength(state.categories),
          products: getProductsSelectedLength(state.categories),
        },
      };
    case UPDATE_PRODUCT_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingSubmit: false,
        categories: state.categories.map(cat =>
          cat.id === action.categoryId
            ? {
                ...cat,
                checked: cat.products.every(prod =>
                  action.productId === prod.id
                    ? prod.status !== PRODUCT_STATUS.INACTIVE && cat.products.length > 1
                    : isProductCheckedOrInactive(prod)
                ),
                products: cat.products.map(prod =>
                  prod.id === action.productId
                    ? {
                        ...prod,
                        checked: false,
                        status:
                          prod.status === PRODUCT_STATUS.ACTIVE
                            ? PRODUCT_STATUS.INACTIVE
                            : PRODUCT_STATUS.ACTIVE,
                      }
                    : prod
                ),
              }
            : cat
        ),
      };
    case INSERT_NEW_CATEGORY_IN_PRODUCTS_LIST:
      return {
        ...state,
        categories: [
          {
            ...action.category,
            products: [],
          },
          ...state.categories.map(cat => ({
            ...cat,
            sortOrder: cat.sortOrder + 1,
          })),
        ],
      };
    case UPDATE_PRODUCT_CATEGORY_NAME:
      return {
        ...state,
        categories: state.categories.map(cat =>
          cat.id === action.idCategory
            ? {
                ...cat,
                name: action.name,
              }
            : cat
        ),
      };
    default:
      return state;
  }
}

const getCategoriesSelectedLength = categories =>
  categories.filter(
    cat => cat.checked && cat.products.every(prod => isProductCheckedOrInactive(prod))
  ).length;

const getProductsSelectedLength = categories => {
  let count = 0;
  categories.forEach(cat => {
    count += cat.products.filter(prod => prod.checked).length;
  });

  return count;
};

const toggleCategory = (catId, categories) => {
  return categories.map(cat => {
    return cat.id === catId
      ? {
          ...cat,
          checked: !cat.checked,
          products: cat.products.map(prod => ({
            ...prod,
            checked: isProductInactive(prod) ? false : !cat.checked,
          })),
        }
      : cat;
  });
};

const toggleProduct = (catId, prodId, categories) => {
  return categories.map(cat => {
    const isProductChecked = cat.products.some(p => p.id === prodId && !p.checked);
    const isCategoryChecked =
      cat.products.filter(p => p.id !== prodId).every(prod => isProductCheckedOrInactive(prod)) &&
      isProductChecked;
    return cat.id === catId
      ? {
          ...cat,
          products: cat.products.map(prod =>
            prod.id === prodId
              ? {
                  ...prod,
                  checked: isProductInactive(prod) ? false : !prod.checked,
                }
              : prod
          ),
          checked: isCategoryChecked,
        }
      : cat;
  });
};

const swapPositions = (array, currPos, newPos) => {
  const item = array[currPos];

  array.splice(currPos, 1);
  array.splice(newPos, 0, item);

  return array.map((arrayItem, index) => ({ ...arrayItem, sortOrder: index + 1 }));
};



// WEBPACK FOOTER //
// ./src/store/products/reducer.js